<template>
    <button type="submit" :disabled="!this.enabled" v-html="label">
    </button>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        enabled: !this.disabled
      }
    },
    mounted() {
      this.$root.$emit('register-submit', this);
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/FormSubmit.vue